export class Base64Util {
  static toBase64(str: string): string {
    return Buffer.from(str).toString('base64');
  }
}
